import React, { Component, PropTypes } from "react";
import Button from "muicss/lib/react/button";

export default class DashboardCard extends Component {
  static propTypes = {
    imgUrl: PropTypes.string,
    themeHeadline: PropTypes.string,
    onLinkClick: PropTypes.func,
    icon: PropTypes.string,
    itemValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedItemValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    href: PropTypes.string,
    buttonText: PropTypes.string,
    navlink: PropTypes.string,
    newTab: PropTypes.bool,
  };
  constructor() {
    super();
    this.onThemeClick = this.onThemeClick.bind(this);
  }

  onThemeClick() {
    const { itemValue, onLinkClick, navlink, newTab } = this.props;
    if (onLinkClick) {
      onLinkClick(itemValue);
    } else if (navlink) {
      window.open(navlink, newTab ? "_blank" : "_self", "noreferrer");
    }
  }

  render() {
    const {
      imgUrl,
      themeHeadline,
      displayName,
      buttonText,
    } = this.props;
    return (
      <div className={"ad-space-card flex-col"}>
        <img src={imgUrl} alt={"card-img"} className={"full-width"} />
        <div className={"card-content justify-between"}>
          <div>
            <h2 className={"font-24 font-semibold mui--text-dark text-center mt-0"}>
              {themeHeadline}
            </h2>
            <p className={"mui--text-dark text-center font-14"}>{displayName}</p>
          </div>

          <Button onClick={this.onThemeClick} className="mui-btn--success">
            {buttonText}
          </Button>
        </div>
      </div>
    );
  }
}
